import{PRODUCT_LABEL_ICONS as o}from"../../constants.js";const e=(e,n,s)=>"object"==typeof e&&"icon"in e&&"label"in e?{Icon:o[e.icon],message:e.label}:{Icon:o[e],message:s(n[e])};export{e as getLabel};
//# sourceMappingURL=getLabel.js.map
